/* The canvas fills whatever box the consumer gives it. That box needs a *definite* height — a
 * percentage height against `min-height`/flex alone collapses the map to 0. */
.map {
  width: 100%;
  height: 100%;
}

/* The loading and unavailable states, centred in the box the consumer gave us. */
.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: var(--surface-muted);
}
